import { render, staticRenderFns } from "./CategoryMenuItem.vue?vue&type=template&id=758b28b1&scoped=true"
import script from "./CategoryMenuItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryMenuItem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CategoryMenuItem.vue?vue&type=style&index=0&id=758b28b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758b28b1",
  null
  
)

export default component.exports